import React from "react";
import "antd/dist/antd.css";
import Top from "../../../components/common/Top";
import Footer from "../../../components/common/Footer";
import ContactModel from "../../../components/common/ContactModel";
import FreeTrial from "../../../components/FreeTrial";
import Banner from "./Banner";
import ClientCase from "../common/ClientCase";
import { Layout } from "antd";
import actionWays from "../../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../../inphone.scss";
import Customized from "../common/Customized";
import DataValue from "./DataValue";
import TechnicalPositions from "./TechnicalPositions";
import TalentPhilosophy from "./TalentPhilosophy"
import Scenario from "./Scenario";
import Advantage from "./Advantage";
import { adaptation } from "../../../utils/adaptation";
import "../common/index.scss";
const { Content } = Layout;

const bannerObj = {
  imgUrl: require("../../../assets/images/solution/common/banner4.png").default,
  name: "惠联专业IT技术人才解决方案",
  title: "驻场服务平台",
  details: "为企业提供全方位的IT人才服务，助力企业数字化转型",
};
const anchorPointList = [
  { name: "解决方案", link: "customized_id" },
  { name: "产品介绍", link: "productCenter_id" },
  { name: "部署方式", link: "deliver_id" },
  { name: "客户案例", link: "clientCase_id" },
];
const customized = {
  til: "服务流程",
  // dil: "响应国家政策，助力公租房、保租房、人才公寓住房发展",
  imgUrl: require("../../../assets/images/solution/asset/customized1.png")
    .default,
  back: "",
  margin: "70px",
};
const dataValueCon = {
  dataValueObj: {
    til: "数据展示",
    // bgColor: "#f7fafd",
    // dil: "兼容纸张档案、电子档案、数据档案一体化管理",
  },
  dataValueList: [
    {
      value: "2000",
      key: "优质人才驻场",
    },
    {
      value: "6000",
      key: "服务客户人数",
    },
    {
      value: "4.2",
      key: "平均驻场交付时间",
    },
  ],
};
const scenarioCon = {
  scenarioObj: {
    til: "场景应用",
    bgColor: "#f7fafd",
    // dil: "兼容纸张档案、电子档案、数据档案一体化管理",
  },
  scenarioList: [
    {
      details: "企业招聘量大，人才储备不够",
      til: "招聘人才不够",
    },
    {
      details: "因有些项目临时需求人才",
      til: "临时用过需求",
    },
    {
      details: "项目周期短，人员不好协调",
      til: "短期项目",
    },
    {
      details: "企业编制名额少，用工有需求",
      til: "企业无编制",
    },
    {
      details: "职业技能要求高，人才少",
      til: "专业技能招聘难",
    },
    {
      details: "需专业人才协助完成",
      til: "新业务线开拓",
    },
  ],
};
const advantageCon = {
  advantageObj: {
    til: "驻场优势",
    bgColor: "#f7fafd",
    // dil: "兼容纸张档案、电子档案、数据档案一体化管理",
  },
  advantageList: [
    {
      til: "人才储备丰富",
      details: "拥有超过 10000+ 优质 IT 人才资源，覆盖各类技术岗位",
      imgUrl:
        require("../../../assets/images/solution/residency/advantage1.png")
          .default,
    },
    {
      til: "快速响应",
      details: "48 小时内提供合适候选人，7 天内完成人员到岗",
      imgUrl:
        require("../../../assets/images/solution/residency/advantage2.png")
          .default,
    },
    {
      til: "品质保证",
      details: "严格的人才筛选机制，确保人才质量和专业能力",
      imgUrl:
        require("../../../assets/images/solution/residency/advantage3.png")
          .default,
    },
    {
      til: "一站式服务",
      details: "提供招聘、培训、管理等全方位人才服务解决方案",
      imgUrl:
        require("../../../assets/images/solution/residency/advantage4.png")
          .default,
    },
  ],
};

class Guaranteed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  }
  render() {
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* banner图 start*/}
          <Banner bannerObj={bannerObj}  active={4}/>
          {/* banner图 end*/}
          {/* 锚点 start*/}
          {/* <AnchorPoint anchorPointList={anchorPointList} /> */}
          {/* 锚点 end*/}
          {/* 场景应用 start*/}
          <Scenario/>
          {/* 服务价值 start*/}
          <DataValue/>
          {/* 驻场优势 start*/}
          <Advantage advantageCon={advantageCon} />
          {/* 技术岗位 */}
          <TechnicalPositions />
          {/* 人才理念 start */}
          <TalentPhilosophy />
          {/* 人才理念 end  */}
          {/* 服务流程 start*/}
          {/* <Customized customizedObj={customized} /> */}
          {/* 客服 start*/}
          {/* <ClientCase /> */}
          {/* 客户服务 end*/}
          {/* 在线体验 start*/}
          <FreeTrial />
          {/* 在线体验 end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Guaranteed));
